import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Spinner from './spinner';

/** Страница ассета, список предсталений */
class ViewSelect extends React.Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.addView = this.addView.bind(this);
	}
	componentDidMount(){
		this.props.model.getViews(this.props.asset.id)
			.then(response => {
				this.setState({ list: response.list });
			})
	}

	addView(e, cls){
		console.log('addView', cls)
		console.log(this.props.ontology)
		let item = this.props.ontology.createInstance(cls)
		item.asset_id = this.props.asset.id
		console.log('new instance: ', item)
		this.props.goView(e, item)
	}


	renderIcon (type) {
		switch (type) {
			case 'list':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z'/></svg>);
			case 'table':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path fill='currentColor' d='M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z'/></svg>);
			case 'tree':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'><path fill='currentColor' d='M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z'/></svg>);
			case 'graph':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512'><path fill='currentColor' d='M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z'/></svg>);
			case 'multi':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='currentColor' d='m448,80l0,352c0,26.5 -21.5,48 -48,48l-352,0c-26.5,0 -48,-21.5 -48,-48l0,-352c0,-26.5 21.5,-48 48,-48l352,0c26.5,0 48,21.5 48,48zm-48,346l0,-340c0,-3.3 -2.7,-6 -6,-6l-340,0c-3.3,0 -6,2.7 -6,6l0,340c0,3.3 2.7,6 6,6l340,0c3.3,0 6,-2.7 6,-6z'/></svg>);
			case 'html':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='currentColor' d='M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z'/></svg>);
			case 'cmp':
				return (<svg className='svg-icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512'><path fill='currentColor' d='M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z'/></svg>);
			case 'exporter':
				return (<svg className='svg-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill='currentColor' d="M192 312C192 298.8 202.8 288 216 288H384V160H256c-17.67 0-32-14.33-32-32L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48v-128H216C202.8 336 192 325.3 192 312zM256 0v128h128L256 0zM568.1 295l-80-80c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L494.1 288H384v48h110.1l-39.03 39.03C450.3 379.7 448 385.8 448 392s2.344 12.28 7.031 16.97c9.375 9.375 24.56 9.375 33.94 0l80-80C578.3 319.6 578.3 304.4 568.1 295z"/></svg>);
			default:
				throw 'illegal view type: ' + type;
		}
	}

	renderList(ontology, list) {
		return (
			<div className='list-group'>
				{list.map(item => (
					<a
						key       = {item.id}
						onClick   = {(e) => this.props.goView(e, item)}
						className = 'list-group-item list-group-item-action'
					>
						<h3>
							{this.renderIcon(item.type)}
							{ontology.getViewTitle(item)}
							{ontology.markAsHidden(item)}
						</h3>
						<p>{ontology.getViewDescription(item)}</p>
					</a>

				))}
			</div>
		);
	}

	render(){
		const ontology = this.props.ontology 
		const classes = ontology.getClasses()
		//const list = (this.state.list)?this.state.list.filter(item => item.type != "graph"): this.state.list;
		//Добавлен фильтр, скрывающий элементы имеющие флаг "Не показывать в общем списке"
		const views = this.state.list; 
		const list = (!views)?views: views.filter(item => item['hide_in_list'] !== 'true');
		//Добавлена сортировка по типу представления и алфавиту
		//console.log(this, list);
		if (Array.isArray(list))
			list.sort((a,b) => (a.type > b.type) ? -1 : ((b.type > a.type) ? 1 : ((a.view_title> b.view_title)?1:(a.view_title < b.view_title)?-1:0)));
		if(! list)
			return (<Spinner text="Загрузка списка..."/>)

					let _tabs = {
			'table': {name: 'Списки и Таблицы',  list: []},
			'tree':  {name: 'Деревья',           list: []},
			'env':   {name: 'Окружение',         list: []},
			'graph': {name: 'Графы',             list: []},
			'html':  {name: 'Материалы',         list: []},
			'cmp':   {name: 'Сравнения',         list: []},
			'exporter': {name: 'Тексты',         list: []},
			'all':   {name: 'Все представления', list: list},
		};
		for (let i = 0; i < list.length;  i++) {
			const view = list[i];
			switch (view.type) {
				case 'list':
				case 'table':
				case 'multi':
					_tabs['table'].list.push(view);
					break;
				case 'tree':
					_tabs['tree'].list.push(view);
					break;
				case 'graph':
					_tabs['graph'].list.push(view);
					break;
				case 'html':
					_tabs['html'].list.push(view);
					break;
				case 'cmp':
					_tabs['cmp'].list.push(view);
					break;
				case 'exporter':
					_tabs['exporter'].list.push(view);
					break;
			}
		}
		let tabs = [];
		for(let t in _tabs) {
			const tab = _tabs[t];
			if (tab.list.length > 0) {
				tabs.push({id: t, name: tab.name, list: tab.list});
			}
		}

		return(
			<div>
				<div className="list-group">
				{(list.length<=0) && <div>Нет настроенных представлений содержимого элемента каталога</div>}
				<Tabs>
					<TabList>{tabs.map(item => (
						<Tab key={item.id}>{item.name}</Tab>
					))}</TabList>
					{tabs.map(item => (<TabPanel key={item.id}>
						{this.renderList(ontology, item.list)}
					</TabPanel>))}
				</Tabs>

				</div>
			</div>
		)
	}

}

export default ViewSelect;


